import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NgForm} from '@angular/forms';

import {PasswordResetFinish} from './password-reset-finish.service';
import {ErrorService} from './../../../shared/services/error.service';

export enum ResetResult {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR'
}

@Component({
    selector: 'jhi-password-reset-finish',
    templateUrl: './password-reset-finish.component.html',
    styleUrls: ['password-reset-finish.component.scss']
})
export class PasswordResetFinishComponent implements OnInit, AfterViewInit {

    confirmPassword: string;
    keyMissing: boolean;
    resetAccount: any;
    key: string;

    @ViewChild(NgForm)
    form: NgForm;

    resetResult: ResetResult;
    ResetResultEnum = ResetResult

    @ViewChild('password', { read : ElementRef }) passwordInputElement: ElementRef;

    constructor(
        private passwordResetFinish: PasswordResetFinish,
        private route: ActivatedRoute,
        private router: Router,
        private errorService: ErrorService
    ) {}

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.key = params['key'];
        });
        this.resetAccount = {};
        this.keyMissing = !this.key;
    }

    ngAfterViewInit() {
        if (this.passwordInputElement != null) {
            this.passwordInputElement.nativeElement.focus();
        }
    }

    finishReset() {
        this.resetResult = null;
        if (this.form.valid) {
            this.passwordResetFinish
                .save({ key: this.key, newPassword: this.resetAccount.password })
                .subscribe(
                    () => this.resetResult = ResetResult.SUCCESS,
                    () => this.resetResult = ResetResult.ERROR
                );
        } else {
            this.errorService.markAllControlsAsTouched(this.form);
        }
    }

    login() {
        this.router.navigate(['authentication']);
    }

    updateValueAndValidity(controlNames: string[]) {
        (controlNames || [])
            .map(controlName => this.form.controls[controlName])
            .filter(control => control && control.touched)
            .forEach(control => control.updateValueAndValidity());
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/password-reset/finish/password-reset-finish.component.ts